(function () {
    'use strict';

    angular
        .module('app')
        .directive('formCustom', formCustom);

    formCustom.$inject = ['$window'];

    function formCustom($window) {
        var directive = {
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope, element, attrs) {  
            $(document).ready(function () {

                //add datepicker
                $(".ui-datepicker").each(function () {
                    var dateFieldFormat = $(this).data('format');
                    $(this).datepicker({
                        dateFormat: dateFieldFormat,
                        onClose: function() {
                            var val = $(this).val();
                            var input = $(this).closest('.ui-datepicker');

                            if (!val) {
                                input.removeClass('has-value');
                                input.siblings('label').removeClass('focused');
                            } else {
                                input.addClass('has-value');
                            }
                        }
                    });
                });

                $('.upload-btn').on('click', function () {
                    $(this).siblings("input.FormFileUpload__Input").click(); //MODIFIED

                });

                $('input.FormFileUpload__Input').on('change',
                    function () {
                        var files = $(this).get(0).files;
                        var result = $(this).siblings('#result');
                        result.html('<p>Your file size is: ' +
                            files[0].size / 1000 +
                            ' kbytes (' +
                            files[0].size +
                            ' bytes)</p>');
                        for (var i = 0; i < files.length; i++) {
                            // get item
                            var file = files[i];
                            result.append($("<p></p>").text(file.name));
                        }
                    });

                //Reset form by refreshing page
                $('.reset-btn').on('click', function() {
                    location.reload();
                });

                // Default dropdown action to show/hide dropdown content
                $('.js-dropp-action').click(function (e) {
                    e.preventDefault();
                    $(this).toggleClass('js-open');
                    $(this).parent().next('.dropp-body').toggleClass('js-open');
                });

                // Using as fake input select dropdown
                $('label.radio').click(function () {
                    $(this).addClass('js-open').siblings().removeClass('js-open');
                    //$('.dropp-body,.js-dropp-action').removeClass('js-open');
				});

	            $('label.check').click(function () {
		            $(this).toggleClass('js-open');
		            //$('.dropp-body,.js-dropp-action').removeClass('js-open');
				});

	            $('.dropp-body label').click(function () {
		            $(this).addClass('js-open').siblings().removeClass('js-open');
		            $('.dropp-body,.js-dropp-action').removeClass('js-open');
	            });


                // get the value of checked input radio and display as dropp title - MODIFIED            
                $('.dropp-body label').click(function () {
                    var value = $(this).text();
                    $(this).parent('.dropp-body').siblings('.dropp-header').children('.js-value').text(value);
                    //set hidden option selected - ADDED
                    var id = "#" + $(this).attr("for");
                    $(id).attr("selected", "selected");
                });

                //ADDED
                //$('.Form__MainBody').addClass('container');                
                //move title and description under Form__MainBody
                $('.Form__Title').insertBefore($('.Form__MainBody section'));
                $('.Form__Description').insertAfter($('.Form__MainBody .Form__Title'));
                //change h2 title to h1
                var title = $('.Form__Title').html();
                var desc = $('.Form__Description').html();
                $('.Form__Title').replaceWith($('<h1>' + title + '</h1>'));
                $('.Form__Description').replaceWith($('<p>' + desc + '</p>'));
                //add class to submit button
                $('.Form__MainBody section .submitbuttonelementblock').addClass('submit-form-row');
                $('.Form__MainBody section .submitbuttonelementblock button').addClass('gradient-btn');
                $('.Form__MainBody section .resetbuttonelementblock ').addClass('submit-form-row');
				$('.Form__MainBody section .resetbuttonelementblock  input').addClass('gradient-btn');

                //add class to checkbox/radio button groups
                $('.Form__MainBody section .choiceelementblock').addClass('form-items checkbox-row');    

                //add class to dropdown
                $('.Form__MainBody section .selectionelementblock').addClass('no-padding-d');
            });

            $(function () {

                $('.EPiServerForms .FormTextbox input').focusout(function () {
                    var text_val = $(this).val();
                    var date_picker = $(this).hasClass('ui-datepicker');

                    if (!date_picker) {
                        if (text_val === "") {
                            $(this).removeClass('has-value');
                            $(this).siblings('label').removeClass('focused'); //ADDED 
                        } else {
                            $(this).addClass('has-value');
                        }
                    }

                });

                //ADDED 
                $('.EPiServerForms .FormTextbox input').focusin(function () {
                    $(this).siblings('label').addClass('focused');
                });

                //ADDED
                //hide episerver input element and build file list dynamically
                //$('.EPiServerForms .fileuploadelementblock .FormFileUpload input[multiple]').css("display", "none");
                //listen to file upload

                //ADDED
                //fix date picker focus issue
                $('.EPiServerForms .FormTextbox input').change(function() {
                    if ($(this).val() != "")
                        $(this).siblings('label').addClass('focused');
                });
            });
        }
    }

})();





//////////////////
// WEBPACK FOOTER
// ./static/common/js/directives/_formCustom.js
// module id = 18
// module chunks = 0